/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.209.1-v202610201751-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqNotificationConfigurationsApiClass {
 
   constructor() {}

  /**
   * @summary Create a new notification on the table
   * @param {string} tableId - The Seeq ID of the table
  */
  public createTableNotificationConfiguration(
    body: models.TableNotificationConfigurationInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/notification-configurations/table/${encodeURIComponent(String(tableId))}`
      .replace('{tableId}', encodeURIComponent(String(tableId)));
    const urlTemplate = `${baseUrl}/notification-configurations/table/{tableId}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableNotificationConfigurationOutputV1>;
  }

  /**
   * @summary Delete a notification configuration
   * @param {string} id - The Seeq ID of the notifiable item
  */
  public deleteNotificationConfiguration(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/notification-configurations/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/notification-configurations/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Delete the notification configuration
   * @param {string} tableId - The Seeq ID of the table
   * @param {string} configurationId - The id of the notification configuration to delete
  */
  public deleteTableNotificationConfiguration(
    {
      tableId,
      configurationId
    } : {
      tableId: string,
      configurationId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }

    if (configurationId === null || configurationId === undefined) {
      throw new Error("'configurationId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/notification-configurations/table/${encodeURIComponent(String(tableId))}/configurations/${encodeURIComponent(String(configurationId))}`
      .replace('{tableId}', encodeURIComponent(String(tableId)))
      .replace('{configurationId}', encodeURIComponent(String(configurationId)));
    const urlTemplate = `${baseUrl}/notification-configurations/table/{tableId}/configurations/{configurationId}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get a notification configuration
   * @param {string} id - The Seeq ID of the notifiable item
  */
  public getNotificationConfiguration(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/notification-configurations/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/notification-configurations/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.NotificationConfigurationOutputV1>;
  }

  /**
   * @summary List a page of the notification configurations on the tables the user can write
   * @param {string} [tableType] - Only configurations on tables of this type
   * @param {boolean} [enabled] - Only configurations in this enabled state
   * @param {number} [offset=0] - The pagination offset, the index of the first configuration in this page of results
   * @param {number} [limit=40] - The pagination limit, the number of configurations in this page of results
  */
  public listAccessibleTableNotificationConfigurations(
    {
      tableType,
      enabled,
      offset,
      limit
    } : {
      tableType?: ListAccessibleTableNotificationConfigurationsTableTypeEnum,
      enabled?: boolean,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/notification-configurations/table`;
    const urlTemplate = `${baseUrl}/notification-configurations/table`;

    const queryParams = {
      ['tableType']: tableType,      ['enabled']: enabled,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TableNotificationConfigurationListOutputV1>;
  }

  /**
   * @summary List the table's notification configurations
   * @param {string} tableId - The Seeq ID of the table
  */
  public listTableNotificationConfigurations(
    {
      tableId
    } : {
      tableId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/notification-configurations/table/${encodeURIComponent(String(tableId))}`
      .replace('{tableId}', encodeURIComponent(String(tableId)));
    const urlTemplate = `${baseUrl}/notification-configurations/table/{tableId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<Array<models.TableNotificationConfigurationOutputV1>>;
  }

  /**
   * @summary Create or update a notification configuration on a condition monitor
   * @param {string} id - The Seeq ID of the condition monitor
  */
  public setNotificationConfigurationForConditionMonitor(
    body: models.ConditionMonitorNotificationConfigurationInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/notification-configurations/condition-monitors/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/notification-configurations/condition-monitors/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.NotificationConfigurationOutputV1>;
  }

  /**
   * @summary Create or update a notification configuration on a report
   * @param {string} id - The Seeq ID of the report
  */
  public setNotificationConfigurationForReport(
    body: models.ReportNotificationConfigurationInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/notification-configurations/reports/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/notification-configurations/reports/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.NotificationConfigurationOutputV1>;
  }

  /**
   * @summary Unsubscribe the current user from the notification on the specified item
   * @param {string} id - The ID of the item to unsubscribe from
  */
  public unsubscribeFromItem(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/notification-configurations/unsubscribe/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/notification-configurations/unsubscribe/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.UnsubscribeOutputV1>;
  }

  /**
   * @summary Update a notification configuration in place
   * @param {string} tableId - The Seeq ID of the table
   * @param {string} configurationId - The id of the notification configuration to update
  */
  public updateTableNotificationConfiguration(
    body: models.TableNotificationConfigurationInputV1,
    {
      tableId,
      configurationId
    } : {
      tableId: string,
      configurationId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }

    if (configurationId === null || configurationId === undefined) {
      throw new Error("'configurationId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/notification-configurations/table/${encodeURIComponent(String(tableId))}/configurations/${encodeURIComponent(String(configurationId))}`
      .replace('{tableId}', encodeURIComponent(String(tableId)))
      .replace('{configurationId}', encodeURIComponent(String(configurationId)));
    const urlTemplate = `${baseUrl}/notification-configurations/table/{tableId}/configurations/{configurationId}`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TableNotificationConfigurationOutputV1>;
  }

}

export const ListAccessibleTableNotificationConfigurationsTableTypeEnum = {
    SCALING: 'SCALING',
    SCALINGCSV: 'SCALING_CSV',
    IMPACTREPORT: 'IMPACT_REPORT',
    VANTAGE: 'VANTAGE',
    CAPSULE: 'CAPSULE',
    GENERIC: 'GENERIC',
    FORMULAACROSS: 'FORMULA_ACROSS',
    ITEM: 'ITEM',
    ITEMCSV: 'ITEM_CSV',
    STORED: 'STORED'
} as const;

export type ListAccessibleTableNotificationConfigurationsTableTypeEnum = typeof ListAccessibleTableNotificationConfigurationsTableTypeEnum[keyof typeof ListAccessibleTableNotificationConfigurationsTableTypeEnum];

export const sqNotificationConfigurationsApi = new sqNotificationConfigurationsApiClass();

export type sqNotificationConfigurationsApiEndpoints = {
  'createTableNotificationConfiguration': {
    method: 'post';
    path: '/notification-configurations/table/${encodeURIComponent(String(tableId))}';
    response: models.TableNotificationConfigurationOutputV1;
  };
  'deleteNotificationConfiguration': {
    method: 'delete';
    path: '/notification-configurations/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'deleteTableNotificationConfiguration': {
    method: 'delete';
    path: '/notification-configurations/table/${encodeURIComponent(String(tableId))}/configurations/${encodeURIComponent(String(configurationId))}';
    response: models.StatusMessageBase;
  };
  'getNotificationConfiguration': {
    method: 'get';
    path: '/notification-configurations/${encodeURIComponent(String(id))}';
    response: models.NotificationConfigurationOutputV1;
  };
  'listAccessibleTableNotificationConfigurations': {
    method: 'get';
    path: '/notification-configurations/table';
    response: models.TableNotificationConfigurationListOutputV1;
  };
  'listTableNotificationConfigurations': {
    method: 'get';
    path: '/notification-configurations/table/${encodeURIComponent(String(tableId))}';
    response: Array<models.TableNotificationConfigurationOutputV1>;
  };
  'setNotificationConfigurationForConditionMonitor': {
    method: 'post';
    path: '/notification-configurations/condition-monitors/${encodeURIComponent(String(id))}';
    response: models.NotificationConfigurationOutputV1;
  };
  'setNotificationConfigurationForReport': {
    method: 'post';
    path: '/notification-configurations/reports/${encodeURIComponent(String(id))}';
    response: models.NotificationConfigurationOutputV1;
  };
  'unsubscribeFromItem': {
    method: 'delete';
    path: '/notification-configurations/unsubscribe/${encodeURIComponent(String(id))}';
    response: models.UnsubscribeOutputV1;
  };
  'updateTableNotificationConfiguration': {
    method: 'put';
    path: '/notification-configurations/table/${encodeURIComponent(String(tableId))}/configurations/${encodeURIComponent(String(configurationId))}';
    response: models.TableNotificationConfigurationOutputV1;
  };
};

type ApiCreateTableNotificationConfigurationResponse = models.TableNotificationConfigurationOutputV1;
type ApicreateTableNotificationConfigurationMutationParams = Parameters<typeof sqNotificationConfigurationsApi.createTableNotificationConfiguration> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqNotificationConfigurationsApi.createTableNotificationConfiguration>;

export function useApiCreateTableNotificationConfigurationMutation(
  options?: Omit<UseMutationOptions<ApiCreateTableNotificationConfigurationResponse, AxiosError<SeeqErrorData>,
    ApicreateTableNotificationConfigurationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateTableNotificationConfigurationResponse, AxiosError<SeeqErrorData>,
  ApicreateTableNotificationConfigurationMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateTableNotificationConfigurationMutationParams) =>
      sqNotificationConfigurationsApi.createTableNotificationConfiguration(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteNotificationConfigurationResponse = models.StatusMessageBase;
type ApideleteNotificationConfigurationMutationParams = Parameters<typeof sqNotificationConfigurationsApi.deleteNotificationConfiguration> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqNotificationConfigurationsApi.deleteNotificationConfiguration>;

export function useApiDeleteNotificationConfigurationMutation(
  options?: Omit<UseMutationOptions<ApiDeleteNotificationConfigurationResponse, AxiosError<SeeqErrorData>,
    ApideleteNotificationConfigurationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteNotificationConfigurationResponse, AxiosError<SeeqErrorData>,
  ApideleteNotificationConfigurationMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteNotificationConfigurationMutationParams) =>
      sqNotificationConfigurationsApi.deleteNotificationConfiguration(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteTableNotificationConfigurationResponse = models.StatusMessageBase;
type ApideleteTableNotificationConfigurationMutationParams = Parameters<typeof sqNotificationConfigurationsApi.deleteTableNotificationConfiguration> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqNotificationConfigurationsApi.deleteTableNotificationConfiguration>;

export function useApiDeleteTableNotificationConfigurationMutation(
  options?: Omit<UseMutationOptions<ApiDeleteTableNotificationConfigurationResponse, AxiosError<SeeqErrorData>,
    ApideleteTableNotificationConfigurationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteTableNotificationConfigurationResponse, AxiosError<SeeqErrorData>,
  ApideleteTableNotificationConfigurationMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteTableNotificationConfigurationMutationParams) =>
      sqNotificationConfigurationsApi.deleteTableNotificationConfiguration(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetNotificationConfigurationResponse = models.NotificationConfigurationOutputV1;
export function GetNotificationConfigurationQueryKey(
  params: Parameters<typeof sqNotificationConfigurationsApi.getNotificationConfiguration>[0],
) {
  return ['sqNotificationConfigurationsApi', 'getNotificationConfiguration', params] as const;
}

export function useApiGetNotificationConfigurationQuery(
  params: Parameters<typeof sqNotificationConfigurationsApi.getNotificationConfiguration>[0],
  options?: Omit<UseQueryOptions<ApiGetNotificationConfigurationResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetNotificationConfigurationResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetNotificationConfigurationQueryKey(params),
    queryFn: () =>
      sqNotificationConfigurationsApi.getNotificationConfiguration(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiListAccessibleTableNotificationConfigurationsResponse = models.TableNotificationConfigurationListOutputV1;
export function ListAccessibleTableNotificationConfigurationsQueryKey(
  params: Parameters<typeof sqNotificationConfigurationsApi.listAccessibleTableNotificationConfigurations>[0],
) {
  return ['sqNotificationConfigurationsApi', 'listAccessibleTableNotificationConfigurations', params] as const;
}

export function useApiListAccessibleTableNotificationConfigurationsQuery(
  params: Parameters<typeof sqNotificationConfigurationsApi.listAccessibleTableNotificationConfigurations>[0],
  options?: Omit<UseQueryOptions<ApiListAccessibleTableNotificationConfigurationsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiListAccessibleTableNotificationConfigurationsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: ListAccessibleTableNotificationConfigurationsQueryKey(params),
    queryFn: () =>
      sqNotificationConfigurationsApi.listAccessibleTableNotificationConfigurations(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiListTableNotificationConfigurationsResponse = Array<models.TableNotificationConfigurationOutputV1>;
export function ListTableNotificationConfigurationsQueryKey(
  params: Parameters<typeof sqNotificationConfigurationsApi.listTableNotificationConfigurations>[0],
) {
  return ['sqNotificationConfigurationsApi', 'listTableNotificationConfigurations', params] as const;
}

export function useApiListTableNotificationConfigurationsQuery(
  params: Parameters<typeof sqNotificationConfigurationsApi.listTableNotificationConfigurations>[0],
  options?: Omit<UseQueryOptions<ApiListTableNotificationConfigurationsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiListTableNotificationConfigurationsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: ListTableNotificationConfigurationsQueryKey(params),
    queryFn: () =>
      sqNotificationConfigurationsApi.listTableNotificationConfigurations(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiSetNotificationConfigurationForConditionMonitorResponse = models.NotificationConfigurationOutputV1;
type ApisetNotificationConfigurationForConditionMonitorMutationParams = Parameters<typeof sqNotificationConfigurationsApi.setNotificationConfigurationForConditionMonitor> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqNotificationConfigurationsApi.setNotificationConfigurationForConditionMonitor>;

export function useApiSetNotificationConfigurationForConditionMonitorMutation(
  options?: Omit<UseMutationOptions<ApiSetNotificationConfigurationForConditionMonitorResponse, AxiosError<SeeqErrorData>,
    ApisetNotificationConfigurationForConditionMonitorMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiSetNotificationConfigurationForConditionMonitorResponse, AxiosError<SeeqErrorData>,
  ApisetNotificationConfigurationForConditionMonitorMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApisetNotificationConfigurationForConditionMonitorMutationParams) =>
      sqNotificationConfigurationsApi.setNotificationConfigurationForConditionMonitor(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetNotificationConfigurationForReportResponse = models.NotificationConfigurationOutputV1;
type ApisetNotificationConfigurationForReportMutationParams = Parameters<typeof sqNotificationConfigurationsApi.setNotificationConfigurationForReport> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqNotificationConfigurationsApi.setNotificationConfigurationForReport>;

export function useApiSetNotificationConfigurationForReportMutation(
  options?: Omit<UseMutationOptions<ApiSetNotificationConfigurationForReportResponse, AxiosError<SeeqErrorData>,
    ApisetNotificationConfigurationForReportMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiSetNotificationConfigurationForReportResponse, AxiosError<SeeqErrorData>,
  ApisetNotificationConfigurationForReportMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApisetNotificationConfigurationForReportMutationParams) =>
      sqNotificationConfigurationsApi.setNotificationConfigurationForReport(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUnsubscribeFromItemResponse = models.UnsubscribeOutputV1;
type ApiunsubscribeFromItemMutationParams = Parameters<typeof sqNotificationConfigurationsApi.unsubscribeFromItem> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqNotificationConfigurationsApi.unsubscribeFromItem>;

export function useApiUnsubscribeFromItemMutation(
  options?: Omit<UseMutationOptions<ApiUnsubscribeFromItemResponse, AxiosError<SeeqErrorData>,
    ApiunsubscribeFromItemMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUnsubscribeFromItemResponse, AxiosError<SeeqErrorData>,
  ApiunsubscribeFromItemMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiunsubscribeFromItemMutationParams) =>
      sqNotificationConfigurationsApi.unsubscribeFromItem(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateTableNotificationConfigurationResponse = models.TableNotificationConfigurationOutputV1;
type ApiupdateTableNotificationConfigurationMutationParams = Parameters<typeof sqNotificationConfigurationsApi.updateTableNotificationConfiguration> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqNotificationConfigurationsApi.updateTableNotificationConfiguration>;

export function useApiUpdateTableNotificationConfigurationMutation(
  options?: Omit<UseMutationOptions<ApiUpdateTableNotificationConfigurationResponse, AxiosError<SeeqErrorData>,
    ApiupdateTableNotificationConfigurationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateTableNotificationConfigurationResponse, AxiosError<SeeqErrorData>,
  ApiupdateTableNotificationConfigurationMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateTableNotificationConfigurationMutationParams) =>
      sqNotificationConfigurationsApi.updateTableNotificationConfiguration(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
